import { Component } from '@angular/core';

@Component({
    selector: 'app-recycle-bin-libr-ccp',
    templateUrl: './recycle-bin-libr-ccp.component.html',
    styleUrls: ['./recycle-bin-libr-ccp.component.scss'],
    standalone: false
})
export class RecycleBinLibrCCPComponent {

}
